import { FunctionComponent, useState } from "react";
import { AssessmentItem } from "../data";


interface AssessmentAccordionProps {
  items: AssessmentItem[];
}


const AssessmentAccordion: FunctionComponent<AssessmentAccordionProps> = ({ items }) => {
  const [openItems, setOpenItems] = useState<Set<number>>(new Set([0, 1, 2])); // First 3 open by default


  const toggleItem = (index: number) => {
    const newOpenItems = new Set(openItems);
    if (newOpenItems.has(index)) {
      newOpenItems.delete(index);
    } else {
      newOpenItems.add(index);
    }
    setOpenItems(newOpenItems);
  };


  return (
    <div className="space-y-1">
      {items.map((item, index) => (
        <AccordionItem
          key={index}
          item={item}
          isOpen={openItems.has(index)}
          onToggle={() => toggleItem(index)}
        />
      ))}
    </div>
  );
};


interface AccordionItemProps {
  item: AssessmentItem;
  isOpen: boolean;
  onToggle: () => void;
}


const AccordionItem: FunctionComponent<AccordionItemProps> = ({
  item,
  isOpen,
  onToggle
}) => (
  <div className="border border-gray-200 rounded-md">
    <button
      className="w-full px-3 py-2 text-left font-bold hover:bg-gray-50 focus:outline-none focus:bg-gray-50 flex justify-between items-center text-sm"
      onClick={onToggle}
    >
      <span className="flex-1 pr-2">{item.title}</span>
      <span className="text-lg text-primary flex-shrink-0">
        {isOpen ? '−' : '+'}
      </span>
    </button>
    {isOpen && (
      <div className="px-3 pb-2 pt-1 border-t border-gray-100">
        <p className="text-gray-700 text-sm leading-relaxed">{item.description}</p>
      </div>
    )}
  </div>
);


export default AssessmentAccordion;





